import Alpine from "alpinejs";

Alpine.data('MultiSelectDropdown', () => ({
    open: false,
    activeIndex: -1,
    options: null,
    init(){
        this.options = this.$refs.listItems.children;
    },
    moveActive(direction){
        if(direction == 'prev' && this.activeIndex >= 0){
            this.activeIndex--;
        } else if (direction == 'next' && this.activeIndex != this.options.length - 1){
            this.activeIndex++;
        } else {
            return;
        }

        
        if(this.activeIndex >= 0){
            let selectedItem = this.options[this.activeIndex];
            selectedItem.classList.add('bg-primary-100');
        }
        this.clearActiveIndex();
    },
    clearActiveIndex(){
        Array.from(this.options).forEach((item) => {
            item.classList.remove('bg-primary-100');
        })
    },
    selectItem(){
        if(this.activeIndex == -1){
            this.open = !this.open;
        } else if (this.activeIndex >= 0){
            let selectedOption = this.options[this.activeIndex];

            let optionInput = selectedOption.querySelector('input');

            optionInput.click();
        }
    }
}));